import React from "react";

const Alert = ({ msg }) => {
  const [showAlert, setShowAlert] = React.useState(true);
  return (
    <>
      {showAlert ? (
        <div>
          <h2 style={{marginTop:"25px"}}>{msg}</h2>
          <div>The page will be redirected shortly...</div>
        </div>
      ) : null}
    </>
  );
};

export default Alert;
